import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Commands } from "../core/util/commandManager";
import { DialogHelper } from "../core/util/dialogHelper";
import { Config } from "../core/config/config";
import React from "react";


export default class ServerTemplateEditApp extends React.Component<any, any> {
    common = new AppHelper();
    setTabTitle = true;
    templateSelectionDs = [];
    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this._getTemplateSelection();
    }

    private _handleFieldChange = (field, value) => {      
        if (field.model == "entity.Templateid") {

            HTTPService.get<JsonResultClass>("ServerTemplate/LoadTemplateSetting?id=" + value)
                .then(result => {
                    if (result.Code === 0) {
                        Helper.updateEntity(this.props.entity, result.Data);
                        this.setState({});
                    }
                });
        } if (field.model == "entity.SendAllNukreis") {
            if (value) {
                MetaDataHelper.setFieldValue(this.props.entity, "entity.AuswahlNukreise", null);
            }
        }

            this.common.handleFieldChange(field, value);
        
     }

      
    save = (closeAfterSave) => {
        if (this.common.validate()) {
            HTTPService.post<JsonResultClass>(this.props.saveUrl , this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                        this._getTemplateSelection();
                        Helper.updateEntity(this.props.entity, result.Data);
                        this.setState({});
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                });
        }
        else {
            return null;
        }
    }
    private _updateTemplateSelection = (ds) => {
        if (ds) {
            this.templateSelectionDs.length = 0;
            for (var i = 0; i < ds.length; i++) {
                this.templateSelectionDs.push(ds[i]);
            }
            this.common.commandManager.runCommand("entity.Templateid", Commands.RELOADDATASOURCE);
            this.setState({});
        }
    }
    private _getTemplateSelection = () => {
        let url = "ServerTemplate/GetServertemplateAuswahl";
        HTTPService.get(url)
            .then(result => {
                this._updateTemplateSelection(result);
            });
    }
    remove = () => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>("ServerTemplate/DeleteTemplate", this.props.entity)
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            Helper.updateEntity(this.props.entity, result.Data);
                            this._getTemplateSelection();
                            this.setState({});

                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
            }

    render() {
        this.props.dataSources.templateSelectionDs = this.templateSelectionDs;
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this._handleFieldChange });
        return <CommonApp {...props} />;
    }
};